import React from 'react';
import {Box, Paper, Typography} from '@mui/material';

/**
 * One named group of fields in an edit dialog. A long form reads as a few labelled parts
 * rather than one run of inputs, and every dialog groups them the same way.
 *
 * @param title Short heading, set in caps above the fields.
 * @param description Optional line under the heading saying what the group is for.
 * @param accent Marks a panel the form fills in for itself rather than one the reader fills
 * in: tinted, with a bar down the left edge. Reserve it for derived values - it only reads
 * as "this is the result" while the plain sections around it stay plain.
 * @param error Turns the accent bar red. Only meaningful alongside accent.
 * @returns {JSX.Element}
 * @constructor
 */
const IyoFormSection = ({title, description, accent = false, error = false, children}) => (
  <Paper
    variant='outlined'
    sx={{
      p: 2,
      height: '100%',
      ...(accent && {
        borderLeft: 4,
        borderLeftColor: error ? 'error.main' : 'primary.main',
        bgcolor: 'action.hover'
      })
    }}
  >
    <Typography variant='overline' component='div' color='text.secondary'>
      {title}
    </Typography>
    {description && (
      <Typography variant='caption' component='div' color='text.secondary'>
        {description}
      </Typography>
    )}
    <Box sx={{mt: 1.5}}>
      {children}
    </Box>
  </Paper>
);

export default IyoFormSection;
